import { action, observable } from "mobx";
import {
  IMSAProfile,
  INameDetails,
  MSAProfileAPI,
  msaProfileAPI,
} from "./msaApi";

export const msaProfileStoreSymbol: unique symbol = Symbol(
  "msaProfileStoreSymbol"
);
export interface ICapes {
  id: string;
  state: string;
  url: string;
  alias: string;
}
export interface IMSAProfileStore {
  state: IMSAProfileStoreState;
  fetchUserDetails: () => void;
}
export interface IMSAProfileStoreState {
  error: boolean;
  profile?: IMSAProfile;
  fetching: boolean;
  nameDetails: INameDetails;
}

export class MSAProfileStore {
  @observable public state: IMSAProfileStoreState = {
    error: false,
    profile: null,
    fetching: false,
    nameDetails: undefined,
  };
  private static instance: MSAProfileStore;

  constructor(private api: MSAProfileAPI) {
    this.fetchUserDetails();
  }

  static getInstance() {
    if (!MSAProfileStore.instance) {
      MSAProfileStore.instance = new MSAProfileStore(msaProfileAPI());
    }
    return MSAProfileStore.instance;
  }
  public async fetchUserDetails() {
    if (this.state.fetching) {
      return;
    }
    this.setState({ fetching: true });
    const { data, error } = await this.api.getProfile();

    this.setState({ fetching: false, profile: data, error: error });
    this.fetchNameDetails();
  }

  private fetchNameDetails = async () => {
    if (this.state.profile) {
      const { data, ok, error } = await this.api.getProfileNameDetails();
      this.setState({ nameDetails: ok ? data : undefined, error: error });
    }
  };

  @action
  private setState(state: Partial<IMSAProfileStoreState>) {
    this.state = { ...this.state, ...state };
  }
}
